import { Link } from "@mui/material";
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import LoyaltyIcon from '@mui/icons-material/Loyalty';
import { makeStyles } from '@material-ui/core/styles';
import isMobilePhone from 'validator/es/lib/isMobilePhone';
import isUUID from 'validator/es/lib/isUUID';
import { TitleProps } from "react-admin";

export const ShowTitle: React.FC<TitleProps> = ( props ) => {
  const name = `${props?.record?.first_name}${props?.record?.last_name ? ' ' + props?.record?.last_name : ''}`;
  return <span><span style={{fontWeight: 600}}>{name}</span> {props?.record?.id} </span>;
};

export const phoneValidation = (value: string): string | undefined => {
  if (!value) {
    return 'Phone is required';
  }
  const isValidPhoneNumber = isMobilePhone(value);
  if (!isValidPhoneNumber) {
    return 'Not a valid phone number';
  }
  return undefined;
};

/**
 * @param value Fountain UUID provided from client
 * @returns String of error if there is a validation error. Undefined if there is no value or no validation error
 */
export const uuidValidationErrorMessage = (value: string): string | undefined => {
  if (!value) {
    return undefined;
  }
  const isValidUuid = isUUID(value);
  if (!isValidUuid) {
    return 'Not a valid fountain UUID';
  }
  return undefined;
};

export const plusParseFormat = (value:string): string => value.startsWith('+') ? value.trim() : `+${value.trim()}`

const linkStyle = {
  p:'2px 5px', mx: '4px', display: 'flex',alignItems: 'center', color: '#3f51b5',
  ':hover': {
    backgroundColor: 'rgba(63, 81, 181, 0.04)'
  }
};
const iconStyle = {color: '#3f51b5', paddingRight: '0.3em'};

export const OrdersLink = (href: any): JSX.Element => {
  return(
    <Link target="_blank" underline="none" href={href.href} variant="body2" 
      sx={linkStyle}>
      <LocalShippingIcon style={iconStyle}/>
      <span>ORDERS</span>
    </Link>)
}

export const SubscriptionsLink = (href: any): JSX.Element => {
  return(
    <Link target="_blank" underline="none" href={href.href} variant="body2"
      sx={linkStyle}>
      <LoyaltyIcon style={iconStyle}/>
      <span>SUBSCRIPTIONS</span>
    </Link>)
}

const useStyles = makeStyles({
  toolBar: {
    display: 'grid',
    justifyContent: 'space-between',
    gridTemplateColumns: 'auto auto',
    padding: '15px 0'
  } 
});

export const TopToolBar = (props: any): JSX.Element => {
  const classes = useStyles();
  return(
    <div className={classes.toolBar}>
      <div>
        {props.left}
      </div>
      <div>
        {props.right}
      </div>
    </div>
  );
}
